module.exports = __webpack_public_path__ + "media/img/apple-icon-36f3a8cc90ccd5b3c3e0c9fbd9fd1f7c.png";